<style lang="less">
  // @import '../flow.less';
  @import '../flow/base.less';
</style>

<template>
    <Tabs value="name1">
        <TabPane label="基本信息" name="name1">
          <div class="content">
            <div class="main">
                <div>
                    <Row>
                        <Col span="24" :lg="15">
                            <Row class="title">
                                <h4>项目详情</h4>
                            </Row>
                            <div class="info-property">
                                <dl>
                                    <dt>项目(中文名)</dt><dd>{{detail.name}}</dd>
                                </dl>
                                <dl>
                                    <dt>项目(英文名)</dt><dd>{{detail.name_en}}</dd>
                                </dl>
                                <dl>
                                    <dt>项目经理</dt><dd>{{detail.masters}}</dd>
                                </dl>
                                <dl>
                                    <dt>产品经理</dt><dd>{{detail.pms}}</dd>
                                </dl>
                                <dl>
                                    <dt>开发人员</dt><dd>{{detail.developers}}</dd>
                                </dl>
                                <dl>
                                    <dt>测试人员</dt><dd>{{detail.tests}}</dd>
                                </dl>
                                <dl>
                                    <dt>维护人员</dt><dd>{{detail.maintain}}</dd>
                                </dl>
                            </div>
                            <Row class="title margin-top-10">
                              <h4>代码信息</h4>
                            </Row>
                            <div class="info-property">
                                <dl>
                                    <dt>版本管理</dt><dd>{{ detail.code.version_control }}</dd>
                                </dl>
                                <dl>
                                    <dt>项目所在组</dt><dd>{{ detail.code.group }}</dd>
                                </dl>
                                <dl>
                                    <dt>代码地址</dt><dd>{{ detail.code.address }}</dd>
                                </dl>
                                <dl>
                                    <dt>Jenkins地址</dt><dd>{{ detail.code.jenkins }}</dd>
                                </dl>
                           </div>
                        </Col>
                        <Col span="24" :lg="{ span: 8, offset: 1 }">
                            <div class="title margin-top-10">
                                <h4>日志信息</h4>
                            </div>
                            <ProjectLogs :logs = "logs" />
                        </Col>
                    </Row>
                    </div>
               </div>
          </div>
        </TabPane>
        <TabPane label="部署信息" name="name2">
         <div class="content">
            <div class="main">
             <Row>
                    <Col span="24" :lg="15">
                        <Row>
                            <Row>
                                <Row class="title">
                                    <h4>正式环境</h4>
                                </Row>
                                <div class="info-property">
                                    <dl>
                                        <dt>服务器</dt><dd>{{ this.product.server }}</dd>
                                    </dl>
                                    <dl>
                                        <dt>服务器类型</dt><dd>{{ this.product.server_type }}</dd>
                                    </dl>
                                    <dl>
                                        <dt>Jenkins Job</dt><dd>{{ this.product.jenkins_job}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>内网地址</dt><dd>{{ this.product.address_in}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>外网地址</dt><dd>{{ this.product.address_ex}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>数据库信息</dt><dd>{{ databasesElements.product}}</dd>
                                    </dl>
                                </div>
                            </Row>
                        </Row>
                        <Row  class="margin-top-10">
                            <Row class="title">
                                <h4>开发环境</h4>
                            </Row>
                            <div class="info-property">
                                   <dl>
                                    <dt>服务器</dt><dd>{{ this.develop.server }}</dd>
                                    </dl>
                                    <dl>
                                        <dt>服务器类型</dt><dd>{{ this.develop.server_type }}</dd>
                                    </dl>
                                    <dl>
                                        <dt>Jenkins Job</dt><dd>{{ this.develop.jenkins_job}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>内网地址</dt><dd>{{ this.develop.address_in}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>外网地址</dt><dd>{{ this.develop.address_ex}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>数据库信息</dt><dd>{{ databasesElements.develop}}</dd>
                                    </dl>
                            </div>
                        </Row>
                        <Row class="margin-top-10">
                            <Row>
                                <Row class="title">
                                    <h4>测试环境</h4>
                                </Row>
                                <div class="info-property">
                                                                                               <dl>
                                        <dt>服务器</dt><dd>{{ this.test.server }}</dd>
                                    </dl>
                                    <dl>
                                        <dt>服务器类型</dt><dd>{{ this.test.server_type }}</dd>
                                    </dl>
                                    <dl>
                                        <dt>Jenkins Job</dt><dd>{{ this.test.jenkins_job}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>内网地址</dt><dd>{{ this.test.address_in}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>外网地址</dt><dd>{{ this.test.address_ex}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>数据库信息</dt><dd>{{ databasesElements.test}}</dd>
                                    </dl>
                                </div>
                            </Row>
                        </Row>
                    </Col>
                    <!-- <Col>
                         <Row>
                            <Row class="title">
                                <h4>监控信息</h4>
                            </Row>
                            <div class="project-logs">
                                <HostMonitor host={productHosts} />
                            </div>
                            <div class="project-logs">
                                <HostMonitor host={productHosts} dataType="memory" />
                            </div>
                        </Row>
                    </Col> -->
                </Row>
             </div></div>
        </TabPane>
    </Tabs>
</template>
<script>
import { getProjectDetail, fetchProjectLogs, fetchDeploymentData } from '@/api/project'
import ProjectLogs from './ProjectLogs'
export default {
  name: 'ProjectDetail',
  components: {
    'ProjectLogs': ProjectLogs
  },
  data () {
    return {
      detail: {},
      logs: [],
      develop: {},
      test: {},
      product: {},
      databasesElements: {}
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.getProjectDetail(this.$route.query.id)
      }
    }
  },
  methods: {
    getProjectDetail (id) {
      let params = {
        id: id
      }
      getProjectDetail(params).then(res => {
        this.detail = res.data
        this.detail.masters = this.detail.masters ? this.detail.masters.join(',') : ''
        this.detail.pms = this.detail.pms ? this.detail.pms.join(',') : ''
        this.detail.developers = this.detail.developers ? this.detail.developers.join(',') : ''
        this.detail.tests = this.detail.tests ? this.detail.tests.join(',') : ''
        this.detail.maintain = this.detail.maintain ? this.detail.maintain.join(',') : ''
        this.fetchProjectLogs(this.$route.query.id)
        // 这个要放到 tab 切换事件中
        this.fetchDeploymentData(this.$route.query.id, 'develop')
        this.fetchDeploymentData(this.$route.query.id, 'test')
        this.fetchDeploymentData(this.$route.query.id, 'product')
      })
    },
    handleReFresh () {
      // 处理刷新操作
      this.getProjectDetail(this.$route.query.id)
    },
    fetchProjectLogs (projectId) {
      fetchProjectLogs(projectId).then(res => {
        let results = res.data.results
        if (results.log_results instanceof Array) {
          this.logs = results.log_results
        }
      })
    },
    fetchDeploymentData (id, scenes) {
      fetchDeploymentData(id, scenes).then(res => {
        if (scenes === 'develop') {
          this.develop = res.data
        } else if (scenes === 'test') {
          this.test = res.data
        } else if (scenes === 'product') {
          this.product = res.data
        }
      })
    }
  },
  mounted: function () {
    this.getProjectDetail(this.$route.query.id)
  }
}
</script>
